import { render, staticRenderFns } from "./referralModel.vue?vue&type=template&id=bc9f8170&"
import script from "./referralModel.vue?vue&type=script&lang=js&"
export * from "./referralModel.vue?vue&type=script&lang=js&"
import style0 from "./referralModel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports